import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import auditLogService from '../../../services/auditLogService';

const AuditLogFilters = ({ filters, onFilterChange }) => {
  const [users, setUsers] = useState([]);
  const [isExpanded, setIsExpanded] = useState(true);

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {
    const { data } = await auditLogService?.getAuditUsers();
    setUsers(data || []);
  };

  const entityTypes = [
    { value: '', label: 'Todos los tipos' },
    { value: 'work_orders', label: 'Órdenes de Trabajo' },
    { value: 'quotation_items', label: 'Cotizaciones' },
    { value: 'clients', label: 'Clientes' },
    { value: 'vehicles', label: 'Vehículos' },
    { value: 'technical_inspections', label: 'Inspecciones' },
    { value: 'timeline_events', label: 'Eventos de Timeline' },
    { value: 'user_profiles', label: 'Usuarios' }
  ];

  const actionTypes = [
    { value: '', label: 'Todas las acciones' },
    { value: 'create', label: 'Creación' },
    { value: 'update', label: 'Modificación' },
    { value: 'delete', label: 'Eliminación' },
    { value: 'status_change', label: 'Cambio de Estado' },
    { value: 'approval', label: 'Aprobación' },
    { value: 'rejection', label: 'Rechazo' }
  ];

  const handleReset = () => {
    onFilterChange({
      tableName: '',
      action: '',
      userId: '',
      startDate: '',
      endDate: ''
    });
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="flex items-center gap-2 text-sm font-medium text-foreground hover:text-primary transition-smooth"
        >
          <Icon 
            name={isExpanded ? 'ChevronDown' : 'ChevronRight'} 
            size={20} 
          />
          Filtros de Búsqueda
        </button>
        <button
          onClick={handleReset}
          className="flex items-center gap-2 px-3 py-1.5 text-sm text-muted-foreground hover:text-foreground border border-border rounded-lg hover:bg-muted transition-smooth"
        >
          <Icon name="RotateCcw" size={16} />
          Limpiar
        </button>
      </div>
      {isExpanded && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {/* Entity Type Filter */}
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Tipo de Entidad
            </label>
            <Select
              value={filters?.tableName || ''}
              onChange={(e) => onFilterChange({ tableName: e?.target?.value })}
              options={entityTypes}
            />
          </div>

          {/* Action Type Filter */}
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Tipo de Acción
            </label>
            <Select
              value={filters?.action || ''}
              onChange={(e) => onFilterChange({ action: e?.target?.value })}
              options={actionTypes}
            />
          </div>

          {/* User Filter */}
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Usuario
            </label>
            <Select
              value={filters?.userId || ''}
              onChange={(e) => onFilterChange({ userId: e?.target?.value })}
              options={[
                { value: '', label: 'Todos los usuarios' },
                ...users?.map(user => ({
                  value: user?.id,
                  label: user?.fullName || user?.email
                }))
              ]}
            />
          </div>

          {/* Date Range */}
          <div className="grid grid-cols-2 gap-2">
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">
                Desde
              </label>
              <Input
                type="date"
                value={filters?.startDate || ''}
                onChange={(e) => onFilterChange({ startDate: e?.target?.value })}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">
                Hasta
              </label>
              <Input
                type="date"
                value={filters?.endDate || ''}
                onChange={(e) => onFilterChange({ endDate: e?.target?.value })}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AuditLogFilters;